/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Craft_A_Compelling_Narrative_FInputs */

const en_craft_a_compelling_narrative_f = /** @type {(inputs: Craft_A_Compelling_Narrative_FInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Craft a compelling narrative for your audience...`)
};

const es_craft_a_compelling_narrative_f = /** @type {(inputs: Craft_A_Compelling_Narrative_FInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea una narrativa convincente para tu audiencia...`)
};

const fr_craft_a_compelling_narrative_f = /** @type {(inputs: Craft_A_Compelling_Narrative_FInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez une narration captivante pour votre public...`)
};

const de_craft_a_compelling_narrative_f = /** @type {(inputs: Craft_A_Compelling_Narrative_FInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestalte eine fesselnde Erzählung für dein Publikum...`)
};

const ja_craft_a_compelling_narrative_f = /** @type {(inputs: Craft_A_Compelling_Narrative_FInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`視聴者を惹きつける魅力的なストーリーを作りましょう...`)
};

const zh_craft_a_compelling_narrative_f = /** @type {(inputs: Craft_A_Compelling_Narrative_FInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为您的受众撰写一段引人入胜的故事...`)
};

const ar_craft_a_compelling_narrative_f = /** @type {(inputs: Craft_A_Compelling_Narrative_FInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اصنع قصة مقنعة لجمهورك...`)
};

const id_craft_a_compelling_narrative_f = /** @type {(inputs: Craft_A_Compelling_Narrative_FInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat narasi yang menarik untuk audiens Anda...`)
};

const it_craft_a_compelling_narrative_f = /** @type {(inputs: Craft_A_Compelling_Narrative_FInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea una narrazione avvincente per il tuo pubblico...`)
};

const ru_craft_a_compelling_narrative_f = /** @type {(inputs: Craft_A_Compelling_Narrative_FInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создайте убедительное повествование для вашей аудитории...`)
};

const pt_craft_a_compelling_narrative_f = /** @type {(inputs: Craft_A_Compelling_Narrative_FInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie uma narrativa atraente para o seu público...`)
};

const ko_craft_a_compelling_narrative_f = /** @type {(inputs: Craft_A_Compelling_Narrative_FInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`고객을 사로잡을 매력적인 스토리를 작성해 보세요...`)
};

/**
* | output |
* | --- |
* | "Craft a compelling narrative for your audience..." |
*
* @param {Craft_A_Compelling_Narrative_FInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const craft_a_compelling_narrative_f = /** @type {((inputs?: Craft_A_Compelling_Narrative_FInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Craft_A_Compelling_Narrative_FInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_craft_a_compelling_narrative_f(inputs)
	if (locale === "es") return es_craft_a_compelling_narrative_f(inputs)
	if (locale === "fr") return fr_craft_a_compelling_narrative_f(inputs)
	if (locale === "de") return de_craft_a_compelling_narrative_f(inputs)
	if (locale === "ja") return ja_craft_a_compelling_narrative_f(inputs)
	if (locale === "zh") return zh_craft_a_compelling_narrative_f(inputs)
	if (locale === "ar") return ar_craft_a_compelling_narrative_f(inputs)
	if (locale === "id") return id_craft_a_compelling_narrative_f(inputs)
	if (locale === "it") return it_craft_a_compelling_narrative_f(inputs)
	if (locale === "ru") return ru_craft_a_compelling_narrative_f(inputs)
	if (locale === "pt") return pt_craft_a_compelling_narrative_f(inputs)
	return ko_craft_a_compelling_narrative_f(inputs)
});